/* eslint-disable react/prop-types */
import React from "react";

import styled from "styled-components";

import { calcColumnWidth } from ".././utils/layout";

import Line from "./Line";

const SeparatorLayout = styled.div`
  margin: 40px 0 0 0;
  display: flex;
  align-items: center;
  width: ${() => calcColumnWidth(4, 6, "end", true)};
  span {
    margin: 0 16px;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 33px;
    color: var(--theme-neutral-600);
  }

  @media only screen and (max-width: 940px) {
    span {
      margin: 0 16px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 33px;
      color: var(--theme-neutral-600);
    }

    margin: 32px 0 0 0;
    max-width: 500px;
  }
`;

const Separator = ({ className }) => {
  return (
    <SeparatorLayout className={className}>
      <Line width={`${calcColumnWidth(4, 3, "end", true)}`} />
      <span>or</span>
      <Line width={`${calcColumnWidth(4, 3, "end", true)}`} />
    </SeparatorLayout>
  );
};

export default Separator;
